import {
  SAVE_DETAILS_SUCCESS,
  RESET_SAVED_DETAILS,
  TOGGLE_TERMS_AND_CONDITIONS,
  TOGGLE_MARKETING_OFFERS,
} from '../constants'

const initialState = {
  firstName: '',
  lastName: '',
  hasOptedIntoMarketing: false,
  hasAcceptedTerms: false,
  isRegistrationDataSaved: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.response,
        isRegistrationDataSaved: true,
      }
    case RESET_SAVED_DETAILS:
      return {
        ...state,
        isRegistrationDataSaved: false,
      }
    case TOGGLE_TERMS_AND_CONDITIONS:
      return {
        ...state,
        hasAcceptedTerms: action.response,
      }
    case TOGGLE_MARKETING_OFFERS:
      return {
        ...state,
        hasOptedIntoMarketing: action.response,
      }
    default:
      return state
  }
}
